import "../Assets/styles/contact.css"
import { SlLocationPin } from "react-icons/sl";
import { CiPhone, CiMail } from "react-icons/ci";
import { MdOutlinePermPhoneMsg } from "react-icons/md";
import nig from '../Assets/images/contact.png'
import emailjs from '@emailjs/browser';
import toast from 'react-hot-toast';
import { useRef, useState } from "react"

const Contact = () => {

  const form = useRef();
    const [loading, setLoading] = useState(false)
  const sendEmail = (e) => {
    setLoading(true)
    e.preventDefault();
    emailjs.sendForm('service_u5r9l9e', 'template_pjvsoej', form.current, 'gSULIKJWkfY2u3IeJ')
    .then((result) => {
        setLoading(false)
        toast.success('Sent', {
    position: 'top-right',
  })
    }, (error) => {
        setLoading(false)
        toast.error('Something went wrong', {
    position: 'bottom-center',
  })
    });

};
  return (
    <>
      <div className="anon">
        <div className='anon-bg'>
        <h1><MdOutlinePermPhoneMsg/></h1>
        <h4><a href='/home'>Home </a><span className='dot'></span> Contact</h4>
        </div>
      </div>
      <div className='container-lg bitt'>
        <div className='row butty'>
          <div className='col-lg-4 col-md-6 contact-head'>
              <div className='imagert'>
              <SlLocationPin style={{height: '70px', width:"50px", color: '#086ad8'}}/>
              </div>
              <p>Lagos, Nigeria</p>
          </div>
          <div className='col-lg-4 col-md-6 contact-head'>
              <div className='imagert'><CiMail style={{height: '70px', width:"50px", color: '#086ad8'}}/></div>
              <p>Igniotoday@gmail.com</p>
          </div>
          <div className='col-lg-4 col-md-6 contact-head'>
              <div className='imagert'><CiPhone style={{height: '70px', width:"50px", color: '#086ad8'}}/></div>
             <p>+234 706 841 4104</p>
          </div>
        </div>
        <div className='row cform'>
          <div className='col-lg-6'>
            <h1>Have Any Question For Us?</h1>
            <div className='contact-form'>
              <h2>Contact Us</h2>
              <form ref={form} onSubmit={sendEmail}>
              <label for="name">Name</label>
              <input type="text" id="name" name="name" placeholder='Your name' required></input>
              <label for="email">Email:</label>
              <input type="email" id="email" name="email"placeholder='Your email' required></input>
              <label for="message">Message:</label>
              <textarea id="message" name="message" placeholder='Type your question here' required></textarea>
              <button type="submit" value="send">Send Message</button>
              </form>
            </div>
          </div>
          <div className='col-lg-6'>
            <img className='maxi' src={nig} alt='fh'/>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact